import { useEffect, useState } from "react";
import { userStorage } from "@/utils/userStorage";

/**
 * React state mirrored into per-user storage (TTTL-186). `read` turns the
 * stored text (or null) into the initial value — validating it, since
 * storage outlives builds — and `write` turns a value into the text to
 * keep, or null to store the default as absence, so keys only exist while
 * the user deviates from it.
 */
export function usePersistedState<T>(
  key: string,
  read: (raw: string | null) => T,
  write: (value: T) => string | null,
) {
  const [value, setValue] = useState<T>(() => read(userStorage.getItem(key)));

  useEffect(() => {
    const stored = write(value);
    if (stored === null) userStorage.removeItem(key);
    else userStorage.setItem(key, stored);
  }, [key, value, write]);

  return [value, setValue] as const;
}
